'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UITile from 'UIComponents/tile/UITile';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GYPSUM } from 'HubStyleTokens/colors';
const StyledUITile = styled(UITile).withConfig({
  displayName: "ContactsInfoBox__StyledUITile",
  componentId: "sc-1ngrtd4-0"
})(["margin-top:24px;font-size:12px;padding:16px;background-color:", ";"], GYPSUM);
export default function ContactsInfoBox({
  titleKey,
  content,
  showBox
}) {
  return /*#__PURE__*/_jsx(AccordionTransition, {
    open: showBox,
    children: /*#__PURE__*/_jsxs(StyledUITile, {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 500
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: titleKey
        })
      }), content]
    })
  });
}